export const EXT_FEED_VIEWCOUNT_KEY = "EXT-FEED:VIEW_COUNT:";
export const numericIdRegex = /^\d{1,6}$/;
export const poExternalIdRegex = /^PO\/\d{2}-\d{2}\/\d{4}$/i;
export const alphabeticRegex = /^[a-zA-Z\s]{2,}$/;
export const phoneNumberRegex = /^(\+91\s?)?[6-9]\d{9}$/i;
//# sourceMappingURL=constants.js.map